'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearState = exports.setState = exports.getState = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _state = require('state');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getState = function getState(key) {
  if (key instanceof Element) {
    var containerId = _Dom2.default.getContainer(key).dataset.containerId;

    return getState(containerId);
  }

  var cart = _state.state.cart,
      states = (0, _objectWithoutProperties3.default)(_state.state, ['cart']);

  var ids = Object.entries(states).reduce(function (allState, _ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        name = _ref2[0],
        values = _ref2[1];

    return Object.assign({}, allState, values);
  }, {});

  if (_state.state[key]) {
    return _state.state[key];
  } else if (ids[key]) {
    return ids[key];
  }

  return;
};

exports.getState = getState;
var setState = function setState(data) {
  var id = data.id,
      change = data.change,
      container = data.container,
      stateChange = (0, _objectWithoutProperties3.default)(data, ['id', 'change', 'container']);

  var newState = void 0;

  if (id && container) {
    if (_state.state.hasOwnProperty(container)) {
      var oldState = _state.state[container][id];
      newState = Object.assign({ id: id }, oldState, stateChange);
      _state.state[container][id] = newState;
    } else {
      _state.state[container] = {};
      _state.state[container][id] = newState = Object.assign({ id: id }, stateChange);
    }
  } else if (container) {
    var _oldState = _state.state[container];
    newState = Object.assign({}, _oldState, stateChange);
    _state.state[container] = newState;
  }

  var topic = container === change ? _Constants2.default.updateState + '.' + container.toUpperCase() : _Constants2.default.updateState + '.' + container.toUpperCase() + '.' + change.toUpperCase();

  PubSub.publish(topic, { id: id, data: data, state: newState });

  return newState;
};

exports.setState = setState;
var clearState = function clearState(key) {
  var cart = _state.state.cart,
      states = (0, _objectWithoutProperties3.default)(_state.state, ['cart']);

  var _ref3 = Object.entries(states).find(function (_ref5) {
    var _ref6 = (0, _slicedToArray3.default)(_ref5, 2),
        name = _ref6[0],
        values = _ref6[1];

    return Object.keys(values).includes(key);
  }) || [],
      _ref4 = (0, _slicedToArray3.default)(_ref3, 1),
      group = _ref4[0];

  if (_state.state[key]) {
    _state.state[key] = {};
  } else if (group !== undefined) {
    delete _state.state[group][key];
  }

  return _state.state;
};
exports.clearState = clearState;